import { Component, signal, inject, effect, untracked } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { disabled, form, FormField } from '@angular/forms/signals';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

import { tap } from 'rxjs';
import { NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';

import { AssetService } from '../../../services/asset';
import { SpinnerLoaderDirective } from '../../../utilities/directives/spinner-loader.directive';
import { PaginationComponent } from '../../../utilities/components/pagination/pagination.component';
import { ContractSelect } from '../../../utilities/components/contract-select/contract-select';
import { Pagination } from '../../../utilities/classes/pagination';
import { CompanySelect } from "../../../utilities/components/company-select/company-select";
import { DateInput } from '../../../utilities/directives/date-input';
import { CompactDatePipe } from '../../../utilities/pipes/compact-date-pipe';
import { VendorSelect } from '../../../utilities/components/vendor-select/vendor-select';
import { AssetTypeSelect } from '../../../utilities/components/asset-type-select/asset-type-select';
import { ModelSelect } from '../../../utilities/components/model-select/model-select';
import { DeviceModelItem } from '../../../models/asset';

@Component({
  selector: 'fs-device-register',
  imports: [FormField, NgbInputDatepicker, SpinnerLoaderDirective, CompactDatePipe, RouterLink, NgClass, PaginationComponent, ContractSelect, CompanySelect, DateInput, VendorSelect, AssetTypeSelect, ModelSelect],
  templateUrl: './device-register.html',
  styleUrl: './device-register.scss'
})
export class DeviceRegister {
  private readonly assetService = inject(AssetService);

  constructor() {
    effect(() => {
      this.deviceFilter.assetTypeId().value();
      this.deviceFilter.assetVendorId().value();

      untracked(() => {
        this.filterModel.update((model) => {
          if (!model.assetModel) return model;
          return { ...model, assetModel: null };
        });
      });
    });
  }

  protected readonly paginationData: Pagination = new Pagination();

  private readonly initialFilter = {
    aziendaId: '',
    codiceContratto: '',
    assetTypeId: '',
    assetVendorId: '',
    assetModel: null as DeviceModelItem | null,
    imei: '',
    dataInizioServizio: null,
    dataFineServizio: null,
    codiceNoleggio: '',
    statoNoleggio: ''
  };
  private readonly filterModel = signal({ ...this.initialFilter });
  protected readonly deviceFilter = form(this.filterModel, (p) => {
    disabled(p.codiceContratto, { when: ({ valueOf }) => !valueOf(p.aziendaId) });
    disabled(p.assetVendorId, { when: ({ valueOf }) => !valueOf(p.assetTypeId) });
    disabled(p.assetModel, { when: ({ valueOf }) => !valueOf(p.assetVendorId) });
  });

  protected readonly deviceResource = rxResource({
    params: () => {
      const { assetModel, ...deviceFilter } = this.deviceFilter().value();
      return {
        ...deviceFilter,
        assetModelId: assetModel?.id ?? '',
        ...this.paginationData.paginationState()
      };
    },
    stream: ({ params }) => this.assetService.getDeviceRegister(params).pipe(
      tap((response) => this.paginationData.updateTotals(response.totalElements)),
    )
  });

  protected resetFilters(): void {
    this.deviceFilter().reset({ ...this.initialFilter });
    this.paginationData.changePage(1);
  }

}
